import _objectSpread from "/home/chdeploy/jenkins/jenkins/workspace/ch_deploy_webpc_test-jh_clife/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/home/chdeploy/jenkins/jenkins/workspace/ch_deploy_webpc_test-jh_clife/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/chdeploy/jenkins/jenkins/workspace/ch_deploy_webpc_test-jh_clife/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.function.name";
import router from "./router";
import store from "./store";
import { getRouterListWithAuth } from "./routerList.js";
import pageAuth from "./pageAuth.json";
import { Message } from 'element-ui';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import { getToken } from '@/utils/auth'; // get token from cookie
import getPageTitle from '@/utils/get-page-title';
import { userStateAuth } from '@/api/apiUrl';
NProgress.configure({
  showSpinner: false
}); // NProgress Configuration
var menuArr = [];
var whiteList = ['/login']; // no redirect whitelist
var getRouter;
function handleKeepAlive(to) {
  if (to.matched && to.matched.length > 2) {
    for (var i = 0; i < to.matched.length; i++) {
      var element = to.matched[i];
      if (element.components.default.name === 'NoPageRoute') {
        to.matched.splice(i, 1);
        handleKeepAlive(to);
      }
    }
  }
}
var useMenuFun = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(to) {
    var billId, userspec, path, meta, res;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            billId = store.state.accountInfo.accountInfo.billId;
            userspec = store.state.accountInfo.accountInfo.userSpec;
            path = to.path;
            meta = to.meta;
            if (!(typeof meta.auth === 'undefined' || meta.auth.length === 0)) {
              _context.next = 6;
              break;
            }
            return _context.abrupt("return", 'next');
          case 6:
            if (!(path.indexOf('baseBusinessManagement') > -1 || path.indexOf('onlineManager') > -1 || path.indexOf('financialManager') > -1 || path.indexOf('baseBusinessManagement') > -1 || path.indexOf('informationManager') > -1)) {
              _context.next = 26;
              break;
            }
            if (!(billId && meta.userspec.includes(userspec))) {
              _context.next = 18;
              break;
            }
            _context.next = 10;
            return userStateAuth({
              menuName: meta.auth,
              billId: billId
            });
          case 10:
            res = _context.sent;
            if (!res.content) {
              _context.next = 15;
              break;
            }
            return _context.abrupt("return", 'next');
          case 15:
            throw new Error(res.msg);
          case 16:
            _context.next = 24;
            break;
          case 18:
            if (billId) {
              _context.next = 22;
              break;
            }
            throw new Error('未搜索用户');
          case 22:
            if (meta.userspec.includes(userspec)) {
              _context.next = 24;
              break;
            }
            throw new Error('该类型用户不允许进入该菜单');
          case 24:
            _context.next = 35;
            break;
          case 26:
            if (!(path.indexOf('businessQueries') > -1)) {
              _context.next = 34;
              break;
            }
            if (billId) {
              _context.next = 31;
              break;
            }
            throw new Error('未搜索用户');
          case 31:
            return _context.abrupt("return", 'next');
          case 32:
            _context.next = 35;
            break;
          case 34:
            return _context.abrupt("return", 'next');
          case 35:
            return _context.abrupt("return", 'next');
          case 36:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function useMenuFun(_x) {
    return _ref.apply(this, arguments);
  };
}();
router.beforeEach( /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(to, from, next) {
    var hasToken, hash, menu, routerList, routerHidden, i, iro, errorRouter, billId, userspec, useMenu;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            store.commit('permission/SET_CURRENT_PATH', to.path);
            // start progress bar
            NProgress.start();
            handleKeepAlive(to);

            // set page title
            document.title = getPageTitle(to.meta.title);

            // determine whether the user has logged in
            hasToken = getToken();
            if (!hasToken) {
              _context2.next = 50;
              break;
            }
            if (!(to.path === '/login')) {
              _context2.next = 11;
              break;
            }
            // if is logged in, redirect to the home page
            next({
              path: '/'
            });
            NProgress.done();
            _context2.next = 48;
            break;
          case 11:
            // 根据pc字段, 数组去重, pc与app 可能相对路由来说是pc一个页面,app多个页面的对应关系, 过滤出来唯一pc端地址
            hash = {};
            menuArr = menuArr.reduce(function (item, next) {
              hash[next.pc] ? '' : (hash[next.pc] = true && item.push(next), hash);
              return item;
            }, []);
            // 把routerList, childer的在权限列表里的过滤出来
            //  获得账号中的角色数组
            menu = store.state.login.menu; // 从pageAuth选出有role数组包括的角色的对象，与后台返回的menu组成数组menuArr
            pageAuth.map(function (ele) {
              if (menu) {
                menu.map(function (x) {
                  if (ele.auth === x) {
                    menuArr.push(ele);
                  }
                });
              }
              // 没有权限限制的功能模块
              if (!ele.auth) {
                menuArr.push(ele);
              }
              // 非生产环境下，增加非生产环境中需要的菜单
              var domian = window.location.href;
              if (domian.indexOf(process.env.VUE_APP_DOMAIN_NAME) === -1 && ele.auth === 'env_pre') {
                menuArr.push(ele);
              }
            });
            routerList = getRouterListWithAuth(menuArr, menu); // 把routerHidden, childer不是hidden的过滤出来
            routerHidden = JSON.parse(JSON.stringify(routerList));
            for (i = 0; i < routerHidden.length; i++) {
              iro = routerHidden[i];
              if (iro.children) {
                iro.children = iro.children.filter(function (fil) {
                  return !fil.hidden;
                });
              }
            }
            // 过滤childer为空的, 直接不展示
            routerHidden = routerHidden.filter(function (fil) {
              return fil.children && fil.children.length;
            });
            if (getRouter) {
              _context2.next = 43;
              break;
            }
            // 不加这个判断，路由会陷入死循环
            getRouter = routerList; // 动态路由数据
            // 将访问路径输入错误的跳转404的router放在router数组的最后一个，避免路径输入错误后，动态生成的路由刷新后才有效
            errorRouter = {
              path: '*',
              hidden: true,
              redirect: '/404'
            };
            getRouter.push(errorRouter);
            router.addRoutes(getRouter); // 动态添加路由
            global.antRouter = routerHidden; // 将路由数据传递给全局变量，做侧边栏菜单渲染工作
            billId = store.state.accountInfo.accountInfo.billId;
            userspec = store.state.accountInfo.accountInfo.userSpec;
            if (!(routerHidden.length === 1 && routerHidden[0].children.length === 1)) {
              _context2.next = 31;
              break;
            }
            next({
              path: routerHidden[0].path + '/' + routerHidden[0].children[0].path
            });
            _context2.next = 41;
            break;
          case 31:
            if (!((~to.path.indexOf('baseBusinessManagement') || ~to.path.indexOf('onlineManager') || ~to.path.indexOf('financialManager') || ~to.path.indexOf('informationManager')) && to.meta.auth)) {
              _context2.next = 40;
              break;
            }
            if (!(billId && to.meta.userspec.includes(userspec))) {
              _context2.next = 37;
              break;
            }
            _context2.next = 35;
            return userStateAuth({
              menuName: to.meta.auth,
              billId: billId
            }).then(function (res) {
              if (res.content) {
                next();
                getRouter = null;
                NProgress.done();
                return;
              } else {
                Message({
                  type: 'warning',
                  message: res.msg
                });
              }
              NProgress.done();
            });
          case 35:
            _context2.next = 38;
            break;
          case 37:
            if (!billId) {
              Message({
                type: 'warning',
                message: '未搜索用户'
              });
              next({
                path: '/userComprehensiveInfo/userComprehensiveInfo'
              });
            } else if (!to.meta.userspec.includes(userspec)) {
              Message({
                type: 'warning',
                message: '该类型用户不允许进入该菜单'
              });
              next({
                path: '/userComprehensiveInfo/userComprehensiveInfo'
              });
            }
          case 38:
            _context2.next = 41;
            break;
          case 40:
            if (~to.path.indexOf('businessQueries')) {
              if (!billId) {
                Message({
                  type: 'warning',
                  message: '未搜索用户'
                });
                next({
                  path: '/userComprehensiveInfo/userComprehensiveInfo'
                });
              } else {
                next();
              }
            } else {
              next(_objectSpread(_objectSpread({}, to), {}, {
                replace: true
              }));
            }
          case 41:
            _context2.next = 47;
            break;
          case 43:
            _context2.next = 45;
            return useMenuFun(to).catch(function (err) {
              Message({
                type: 'warning',
                message: err.message
              });
              next({
                path: '/userComprehensiveInfo/userComprehensiveInfo'
              });
            }).finally(function () {
              NProgress.done();
            });
          case 45:
            useMenu = _context2.sent;
            if (useMenu === 'next') {
              next();
            } else if (useMenu === 'nextReplace') {
              next(_objectSpread(_objectSpread({}, to), {}, {
                replace: true
              }));
            }
          case 47:
            NProgress.done();
          case 48:
            _context2.next = 51;
            break;
          case 50:
            /* has no token*/

            if (whiteList.indexOf(to.path) !== -1) {
              // in the free login whitelist, go directly
              next();
            } else {
              // other pages that do not have permission to access are redirected to the login page.
              next("/login?redirect=".concat(to.path));
              NProgress.done();
            }
          case 51:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function (_x2, _x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}());
router.afterEach( /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(to, from, next) {
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            // finish progress bar

            store.commit('routerStore/setRouteFromName', from.name);
            NProgress.done();
          case 2:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return function (_x5, _x6, _x7) {
    return _ref3.apply(this, arguments);
  };
}());